import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";

import { useQuery } from "@tanstack/react-query";

import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

export function useFetchLayoutMemberConfig(
  isAuthenticated,
  email,
  userContactType
) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useFetchLayoutMemberConfigValuesKey";

  async function GetMemberConfigData() {
    //alert("GetMemberConfigData for email: " + email);
    const accessToken = oktaAuth.getAccessToken();

    let params = {
      email: email,
    };

    var result = await axios
      .get("api/UserProgram/GetUserDropdownValues", {
        params: params,
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });

    return result;
  }

  function IsEnabled() {
    if (!isAuthenticated) return false;

    if (IsNullOrEmpty(email)) return false;

    return true;
  }

  return useQuery({
    queryKey: [dataKey, email, userContactType],
    queryFn: async () => await GetMemberConfigData(),
    enabled: IsEnabled,
    refetchInterval: 1000 * 60 * 2, // Refetch every 2 minutes, in case location data changes
  });
}
